const errorMessage = (errorcode, error) => {
  const message = {
    ogImageError: 'Please upload the OG Image',
    loginError: "Oops! Please login with your account and try again.",
    isAdminRoleExist: 'Sorry, unable to find this admin role.',
    commonError: 'Oops! Something went wrong. Please try again.',
    catchError: 'Oops! Something went wrong.' + error,
    checkAdminRoleUsed: 'Oops! Unable to delete the admin role due to some admin user using this role.',
    invalidRole: 'Oops, it looks like the chosen role is not valid. Please try with different valid role.',
    emailAlreadyExist: 'Oops! this email address is already exist.',
    userLogin: 'Oops! Please login and continue.',
    invalidError: 'Something went wrong!',
    checkLogin: 'You haven\'t authorized for this action.',
    choosePaymentMethod: 'AtLeast one payment method option must be active.',
    walletEnableError: 'Please enable Stripe Payment to activate the wallet.',
    updateStatusError: "Oops! Couldn't update status!",
    login: 'Please login with your account and continue.',
    unableToInactiveCategory: "Sorry, unable to inactive. The chosen category is used on the manage fare. Please remove the fare and try again.",
    unableToInactiveLocation: "Sorry, unable to inactive. The chosen location is used on the manage fare. Please remove the fare and try again.",
    isCategoryUsed: "Unable to delete this Category  because it is being used by its Sub Categories. Please remove the Sub Category and then try again.",
    isURLUsed: "The page URL already exist!",
    invalidRequest: "Oops! Invalid request",
    checkPreferredCurrency: 'Oops! This currency is used as the preferred currency.',
    findValidCurrency: 'Sorry, Please add the valid currency!',
    currencyAlreadyExist: 'Sorry, it looks like the currency is already exist.',
    geoLocation: 'Geo location is now drawn completely. Try zooming the map and draw closed location boundary.',
    unableToDeleteLocation: "Sorry, unable to delete. The chosen location is used on the manage fare. Please remove the fare and try again.",
    fareAlreadyExist: 'Sorry, it looks like the fare is already exist for the chosen location and category.',
    unableToCreateFare: 'Sorry, unable to create a fare for the chosen location and category.',
    checkBookingExist: 'Sorry, The chosen pricing is having the bookings and unable to disable it.',
    isPromoCodeExist: 'Oops! It looks like already this promo code is used. Please try again with different promo code name.',
    unableToCreateCode: 'Oops! Something went wrong! Unable to create a new promo code. Please try again.',
    unableToDeleteCode: "Oops! something went wrong. Unable to delete the promo code.",
    unableToUpdateCode: 'Oops! Something went wrong! Unable to update the promo code. Please try again.',
    unableToDeleteFareForCategory: "Sorry, unable to delete. The chosen category is used on the manage fare. Please remove the fare and try again.",
    deletedUser: 'Oops! We are unable to find your account. Please contact support for help.',
    unableToDeletePartnerBooking: "Oops! it looks like the service provider has an active booking and so we are unable to delete them right now.",
    updateDocumentError: "Oops! Couldn't update document!",
    checkUserEmailExist: 'Oops, the provided email is already exits with the other user.',
    checkPhoneNumberExist: 'Oops, the provided phone number is already exits with the other user.',
    checkUserBan: "Can't Change the status as currently, they are doing service, Please try again later",
    unableToUpdateUserDetails: 'Oops! Something went wrong, unable to update the user information.',
    adminLogin: 'Please login as an admin and continue the action.',
    unableToDeleteUserBooking: "Oops! it looks like the user has an active booking and so we are unable to delete them right now.",
    unableToCreateAdminUser: "Oops, something went wrong. Unable to create an admin user.",
    noRecords: "No records found.",
    invalidPassword: "Wrong Password. Please try again",
    checkUserEmail: "No account exists for this email. Make sure it's typed in correctly, or “sign up” instead",
    userAlreadyLoggedIn: "You are already logged in!",
    noResults: 'No result found',
    unableToFindBookingDetails: "Oops! Unable to find the booking information.",
    updateExistingCart: 'Your cart has been cleared since the admin has made some changes on the admin panel settings.',
    checkAdminLoggedIn: 'Something went wrong, Please login.',
    checkUserLogin: "Please login for this action.",
    noCategoryFound: 'No category found',
    networkFailed: 'You are offline. Please try again later',
    resendOtp: 'OTP resent successfully',
    updatePaymentMethod: `Your preferred payment method has been updated successfully`,
    cardAddSuccess: `Your card has been successfully added`,
    cardRemove: `The saved card has been removed successfully`,
    walletAmountAdded: `The amount ${error ? error : ''} has been successfully added to your wallet.`,
    maximumAllowedServices: `Oops! Maximum ${error ? error : ''} services is allowed for a booking so kindly make another service request separately.`,
    unableToConnectCard: 'Oops, something went wrong! Unable to connect your card',
    accountBlocked: 'Oops! it looks like your account has been blocked. Please contact support.',
    cardError: 'Sorry, something went wrong with your card. Please try again.',
    updateProfile: 'Your profile has been updated successfully',
    couponNotExist: `Oops! Coupon does not exist. Please remove or change the coupon.`,
    invalidPromoCode: 'Oops! it looks like you provided code is invalid.',
    noPaymentType: 'Oops! The selected payment type is not available at the moment. Please try with different payment type.',
    noWalletAmount: `Your wallet doesn't have enough balance and please top up your wallet balance`,
    noCardDetails: "Add card details to proceed further",
    provideDeliveryLocation: 'Oops! Please provide the delivery location to place your order.',
    noServiceProviderAvailable: "Sorry, no service providers available for your order. Please try again.",
    //Toaster Error Message
    success: 'Success',
    error: 'Error!',
    warning: 'Warning',
    errorMessage: error || 'Oops! something went wrong! Please try again.',
    catchMessage: `Oops! Something went wrong! ${error}`,
    addPromoCodeSuccess: `Promo Code has been ${error ? 'updated' : 'added'
      } successfully.`,
    deletePromoCodeSuccess: `Promo Code has been deleted successfully.`,
    siteSettingsSuccess: `The site settings have been updated successfully!`,
    adminUserSuccess: `Admin User has been ${error ? 'updated' : 'added'
      } successfully.`,
    adminDeleteSuccess: `Admin Role has been deleted successfully!`,
    adminRoleSuccess: `Admin Role has been ${error ? 'updated' : 'added'
      } successfully.`,
    delUser: `${error === 2 ? 'The provider' : 'The user'
      } has been deleted successfully.`,
    adminUserDeleteSuccess: `Admin User has been deleted successfully!`,
    deleteContentSuccess: `Changes are updated!`,
    updateStatusSuccess: `Changes are updated!`,
    editPartnerSuccess: `Service Provider has been updated!`,
    updateHomeSuccess: `Changes are updated!`,
    updateCitySuccess: `Homepage settings changes have been successfully applied!`,
    updateFooterSuccess: `Homepage settings changes have been successfully applied!`,
    mobileSettingsSuccess: `The mobile app settings have been updated successfully!`,
    updateProfileSuccess: `Profile image has been uploaded!`,
    removeCancelSuccess: `Cancel Reason has been deleted successfully.`,
    removeCatSuccess: `The category has been deleted successfully.`,
    failedCurrency: `Sorry, you can't disable the base currency. Try to set a different base currency and disable this one.`,
    successCurrency: `Currency status has changed.`,
    baseCurrency: `Base Currency is set successfully.`,
    allowedCurrency: `Allowed Payment Currency Success.`,
    addCurrency: `Currency has been added successfully.`,
    deleteCurrency: `Currency has been deleted successfully.`,
    failedDeleteCurrency: `Sorry, you can't delete the base currency. Try to set a different base currency and delete this one.`,
    userExp: `User experience has been uploaded!`,
    removeDoc: ` ${error} document has been removed!`,
    userIdentity: `User Identity has been uploaded!`,
    selectLoc: `Please select location!`,
    addLoc: `The Location has been added successfully!`,
    updateLoc: `The Location has been updated successfully!`,
    delLoc: `The Location has been deleted successfully!`,
    updateCashPayout: `Updated status for Cash Payout!`,
    updatePayout: `Updated status!`,
    delFareSuccess: `The fare has been deleted successfully.`,
    statusFareSuccess: `The status has been updated successfully.`,
    updateSms: `The SMS method status has been updated successfully.`,
    addSubCatSuccess: `The sub category has been ${error ? 'updated' : 'added'} successfully.`,
    addSubCatSuccess: `The sub category has been ${error ? 'updated' : 'added'
      } successfully.`,
    removeSubCatSuccess: `The sub category has been deleted successfully.`,
    statusSubCatSuccess: `The sub category status has been updated successfully.`,
    updateUser: `User has been updated!`,
    passwordChange: `Admin details changed successfully!`,
    limitError: error ? `The image that you are trying to upload has exceeded the maximum size limit ${error} MB. Please try again with smaller size.` : `The image that you are trying to upload has exceeded the maximum size limit . Please try again with smaller size.`,
    filetypeError: `You are trying to upload invalid image file. Please upload PNG, JPG & JPEG format image file.`,
    categoryLogo: `Category Logo Image is required.`,
    categoryBanner: `Category Banner Image is required.`,
    subCategoryImage: `SubCategory Image is required.`,
    noCategory: `No categories found.`,
    pleaseUpload: `Please upload image.`,
    addCmsContent: `Please Add  Content.`,
    timer: `Please add timer tone.`,
    addDescription: `Please Add  Description.`,
    pushNotificationSent: `Push notification has been sent.`,
    tempImage: `${error ? 'Your Image has been uploaded.' : 'Your Image has been removed.'}`,
    addCancelSuccess: `Cancel Reason has been ${error ? 'updated' : 'added'} successfully.`,
    addCatSuccess: `The category has been ${error ? 'updated' : 'added'} successfully.`,
    addFareSuccess: `The fare has been ${error ? 'updated' : 'added'} successfully.`,
    tempImage: `${error ? 'Your Image has been uploaded.' : 'Your Image has been removed.'
      }`,
    addCancelSuccess: `Cancel Reason has been ${error ? 'updated' : 'added'
      } successfully.`,
    addCatSuccess: `The category has been ${error ? 'updated' : 'added'
      } successfully.`,
    addFareSuccess: `The fare has been ${error ? 'updated' : 'added'
      } successfully.`,
    updateConfigSettings: `Configurations updated successfully!`,
    updatePaymentStatus: `Payment method status has been updated successfully.`,
    updateStatusFailed: `Failed to update status!`,
    paymentStatusFailed: error ? error : 'Failed to update status!',
    deleteTopFeatureSuccess: `The topfeature has been deleted successfully`,
    updateTopFeatureStatus: `The topfeature has been updated successfully.`,
    userBan: 'This user is banned',
    cashPayment: 'Enable Cash payment in payment method to create booking',
    invalidNumber: 'Invalid phone number',
    serviceUnavailable: "Sorry, our service is currently unavailable in your location.",
    checkIfUserEmail: 'This email already registered',
    checkIfAdminEmail: 'This email already registered by admin',
    noProvidersAvailable: 'Sorry, No providers available for your job. Please try again.',
    cancelBooking: 'Booking has been cancelled successfully.',
    selectPartner: 'Please select the service provider for the service and proceed with the booking process',
    requestDate: 'Chosen time should be ahead of 20 mins from the current time.',
    restrictedDate: 'Oops! You are trying to book a restricted date and time. Please contact our support team.',
    bookPastDates: 'Error! You are only allowed to create a job request for future dates. Please create a job request 20 minutes ahead of the current time',
    updateBooking: 'Booking has been updated successfully.',
    selectData: 'Please select a date',
    invalidOtp: 'Please enter valid OTP',
    failedDeletePayoutCurrency:
      'You cannot delete this currency as it is the preferred payout currency. Please set a different currency as the preferred payout currency before deleting this one.',
    failedPayoutCurrency:
      'You cannot disable this currency as it is the preferred payout currency. Please set a different currency as the preferred payout currency before disabling this one.',
    payoutCurrencyFailed:
      'You are not allowed to update the preferred payout currency',
    payoutCurrencySuccess: 'The payout currency has been updated successfully',
    userCategory: 'User Category has been updated!',
    addedBaseFare: 'The Base fare has been updated successfully.',
    failedBaseFare: 'Sorry, Failed to update the Base fare.',
    googlePayEnableError: `Please enable Stripe Payment to activate the Google Pay.`,
    isAgreePhoneNumberError: 'Please acknowledge the consent message to proceed further.',
    userExist: 'User already exists',
    serviceCancelledByUser: 'Oops! It looks like the service is already cancelled by ',
    serviceCancelledByPartner: 'Oops! It looks like the service is already cancelled by ',
    serviceAlreadyCompleted: 'Oops! It looks like the service is already completed.',
    greaterTipsAmount: "Tips amount should be less than service amount",
    checkWalletBalance: 'Oops! Your wallet amount is not sufficient to make the payment. Please try again with another payment method',
    unableToProcessTransaction: "Unable to process the payment because invalid data was supplied with the transaction. Please try again with another payment method",
    noBookingFound: 'Oops! No such booking found. Please try again.',
    invalidTransaction: `Unable to process the payment because invalid data was supplied with the transaction. Please try again with another payment method ${error}`,
    unableToFindUserProfile: 'Oops! Unable to find your user profile. Please logout and try again.',
    noThreadFound: 'Sorry, no thread found!',
    paymentTypeError: 'Oops! you are not allowed to remove all the currencies. Please make sure that single currency is added.',
    selectCurrency: `Please select the payment currency from the dropdown to proceed further`,
    demoWarning: 'Sorry, you are not allowed to change or remove the demo information.',
    disableDemo: 'This action is disabled on the demo site.',
    promoCodeErrorMessage: 'Heads-up! The push notifications are disabled on the demo website.',
    userLoginCheck: 'Sorry, It looks like you are already logged-in with your account. Please logout and try again.',
    provideValidCredentials: 'Oops! Something went wrong. Please provide valid credentials.',
    unableToCreate: 'Unable to create.',
    requiredInformation: 'Please enter required information.',
    unableToValidatePhoneNumber: 'Unable to validate your phone number',
    unableToCreateAccount: 'Oops! Unable to create the account.',
    adminLoginCheck: 'Sorry, It looks like you are already logged-in as an admin. Please logout and try again.',
    orderNotExist: 'Oops! Order does not exist.',
    alreadyUserLoginError: 'You are already logged in as User, please logout with that account and try again.',
    accountDisabled: 'Oops! It looks like your account is disabled at the moment. Please contact our support.',
    unableToFindAccount: 'Oops! We are unable to find your account. Please contact support for help.',
    deleteCardErrorMessage:'Alert! You are not allowed to delete this payment method as you have an active bookings. Please complete the booking and try again later.',
    configurationSms: 'The SMS method configurations have been updated successfully'

  };
  return message[errorcode];
};
export default errorMessage;
